export default __webpack_public_path__ + "static/useful3-e810a1681d96d786f649845444a1322f.jpg";